import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const ReputationManagementLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to="/dashboard/building-dashboard/reputation-management"
      >
        <span>
          {t('navbar:upsellingLinks.reputationManagement')}
          <NavigationLabel type={NAVIGATION_LABELS.NEW} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

ReputationManagementLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default ReputationManagementLink
